<template>
  <section v-if="recenti.length" class="px-3" :aria-label="t('layout.menu.recenti')" data-test="sidebar-recenti">
    <p class="mb-1.5 text-[10px] font-semibold tracking-widest text-text-muted uppercase">{{ t("layout.menu.recenti") }}</p>
    <div class="flex flex-wrap gap-1.5">
      <UiChip
        v-for="r in recenti"
        :key="r.path"
        :to="r.path"
        :icon="r.icon"
        :label="r.title || t(r.label ?? '')"
        size="sm"
        tone="accent"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
// Le ultime pagine visitate come pillole-link, in testa al menu. Non compare se non ce ne sono. Il menu si chiude da solo al
// cambio di pagina (lo fa AppSidebar).
import { useI18n } from "vue-i18n";
import type { RouteRecente } from "~/composables/useRecentRoutes";

defineProps<{ recenti: RouteRecente[] }>();
const { t } = useI18n();
</script>
